var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55176 11.8015L5.03404 12.2739L4.55176 12.7663L4.06948 12.2739L4.55176 11.8015ZM3.87667 1.59209C3.87667 1.21925 4.17892 0.917005 4.55176 0.917005C4.9246 0.917005 5.22684 1.21925 5.22684 1.59209L3.87667 1.59209ZM9.03404 8.19013L5.03404 12.2739L4.06948 11.3291L8.06948 7.24536L9.03404 8.19013ZM4.06948 12.2739L0.0694791 8.19013L1.03403 7.24536L5.03404 11.3291L4.06948 12.2739ZM3.87667 11.8015L3.87667 1.59209L5.22684 1.59209L5.22684 11.8015L3.87667 11.8015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.39d0d48349ea3aab4206c98ca54b9719.svg";
export { ForwardRef as ReactComponent };